module.exports = __webpack_public_path__ + "static/82221636-0e81-4d7f-a593-345f75c98659-03a2bd5c513932a0580849a68402b3fb.webp";